import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * A custom element that renders arbitrary Liquid and reacts to variant changes.
 * When a variant is selected, the inner content is morphed to match the newly
 * fetched HTML so that metafield values (e.g. scent_notes) stay in sync.
 *
 * Usage: use the "BS Custom Liquid" block instead of the built-in "Custom Liquid"
 * block whenever the Liquid output depends on the selected variant.
 */
class BsCustomLiquid extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateContent);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateContent);
  }

  /**
   * Updates the custom liquid content when the variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateContent = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newContent = event.detail.data.html.querySelector(
      `bs-custom-liquid[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newContent) return;

    morph(this, newContent, { childrenOnly: true });
  };
}

if (!customElements.get('bs-custom-liquid')) {
  customElements.define('bs-custom-liquid', BsCustomLiquid);
}
